import { SvgIcon } from "@mui/material";
import { Cottage as CottageIcon } from "@mui/icons-material";

import { EmissionType } from "src/types";
import { ReactComponent as IndustryIcon } from "src/assets/icons/industry.svg";
import { ReactComponent as RoadIcon } from "src/assets/icons/road.svg";

export function EmissionListItemIcon(props: { type: EmissionType }) {
  if (props.type === EmissionType.TRAFFIC) {
    return <SvgIcon component={RoadIcon} viewBox="0 0 24 16" />;
  } else if (props.type === EmissionType.POINT_SOURCE) {
    return <SvgIcon component={IndustryIcon} viewBox="0 0 23.215 20.313" />;
  } else if (props.type === EmissionType.RESIDENTIAL) {
    return <CottageIcon fontSize="large" />;
  }
  return null;
}
